import { resetUser } from "../../lib/mixpanel"

export const logout = () => {
   localStorage.removeItem("token")
   localStorage.removeItem("loginMode")
   localStorage.removeItem("refreshTokenExpiryTime")
   localStorage.removeItem("refreshToken")
   localStorage.removeItem("tokenExpiryTime")

   localStorage.removeItem("idleTime")

   localStorage.removeItem("userId")

   // Clear the cached Community persona so it can't leak into the next session.
   localStorage.removeItem("communityRole")

   // Clear the Mixpanel identity + super properties (incl. the `mobile`
   // registered at login) so the next session starts clean and the
   // previous user's phone number doesn't leak onto anonymous events.
   resetUser()
}